import React from "react";
import MenuItem from "@mui/material/MenuItem";
import { FormHelperText, Select, Checkbox, ListItemText } from "@mui/material";

const SelectOptions = ({
  options = [],
  formData = {},
  onUpdate = () => {},
  name = "",
  labelKey = "",
  valueKey = "",
  errorText = "",
  defaultText = "Select Option",
  disabled = false,
  multiple = false,
}) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    onUpdate(name, value);
  };

  return (
    <>
      <Select
        sx={{ maxWidth: "100%" }}
        fullWidth
        name={name}
        value={formData[name] || (multiple ? [] : "")}
        onChange={handleChange}
        error={!!errorText}
        size="small"
        displayEmpty
        disabled={disabled}
        className="select"
        multiple={multiple}
        renderValue={
          multiple
            ? (selected) => {
                if (selected.length === 0) {
                  return <em className="select">{defaultText}</em>;
                }
                return options
                  .filter((option) => selected.includes(option[valueKey]))
                  .map((option) => option[labelKey])
                  .join(", ");
              }
            : undefined
        }
      >
        {!multiple && (
          <MenuItem value="" disabled>
            <em className="select">{defaultText}</em>
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem key={option[valueKey]} value={option[valueKey]}>
            {multiple && (
              <Checkbox
                size="small"
                checked={(formData[name] || []).indexOf(option[valueKey]) > -1}
              />
            )}
            <ListItemText primary={option[labelKey]} />
          </MenuItem>
        ))}
      </Select>
      {errorText && <FormHelperText error>{errorText}</FormHelperText>}
    </>
  );
};

export default SelectOptions;
